// src/components/Sidebar.js
import React from 'react'
import {
  Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText,
  Divider, Toolbar, Box, Typography, Chip
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import PaymentIcon from '@mui/icons-material/Payment'
import AssessmentIcon from '@mui/icons-material/Assessment'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import LogoutIcon from '@mui/icons-material/Logout'
import { IconButton } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'

const drawerWidth = 240

export default function Sidebar({ onLogout, userRole = 'user' }) {
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const location = useLocation()
  const toggleDrawer = () => setMobileOpen(!mobileOpen)

  const commonMenuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { text: 'Vehicles', icon: <DirectionsCarIcon />, path: '/vehicles' },
    { text: 'Payments', icon: <PaymentIcon />, path: '/payments' },
    { text: 'General Report', icon: <AssessmentIcon />, path: '/reports' },
    { text: 'Missing Report', icon: <AssessmentIcon />, path: '/reports/missing' },
    { text: 'Profit & Loss', icon: <AssessmentIcon />, path: '/reports/profit' },
    { text: 'Specific Report', icon: <AssessmentIcon />, path: '/reports/specific' },
  ]

  const adminMenuItems =
    userRole === 'admin'
      ? [{ text: 'User Approvals', icon: <AdminPanelSettingsIcon />, path: '/admin/approvals' }]
      : []

  const allItems = [...commonMenuItems, ...adminMenuItems]

  const drawerContent = (
    <Box sx={{ width: drawerWidth, bgcolor: '#1e1e2f', color: 'white', height: '100%' }}>
      <Toolbar sx={{ justifyContent: 'space-between', py: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="white">BB&M</Typography>
        {userRole === 'admin' && (
          <Chip
            size="small"
            icon={<AdminPanelSettingsIcon sx={{ color: 'inherit !important' }} />}
            label="Admin"
            sx={{ bgcolor: 'rgba(255,255,255,0.12)', color: 'white' }}
          />
        )}
      </Toolbar>

      <Divider sx={{ bgcolor: 'gray' }} />

      <List sx={{ py: 1 }}>
        {allItems.map((item) => {
          const selected = location.pathname === item.path
          return (
            <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                component={Link}
                to={item.path}
                selected={selected}
                sx={{
                  color: 'white',
                  '&.Mui-selected': { bgcolor: '#333' },
                  '&:hover': { bgcolor: '#333' },
                }}
              >
                <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          )
        })}

        <Divider sx={{ bgcolor: 'gray', mt: 1.5, mb: 0.5 }} />

        <ListItem disablePadding sx={{ mt: 0.5 }}>
          <ListItemButton
            onClick={onLogout}
            sx={{
              color: 'white',
              '&:hover': { bgcolor: '#c62828' },
            }}
          >
            <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  )

  return (
    <>
      {/* Mobile Toggle Button */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, position: 'fixed', top: 8, left: 8, zIndex: 1300 }}>
        <IconButton onClick={toggleDrawer} color="inherit" size="large">
          <MenuIcon />
        </IconButton>
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' }
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: '#1e1e2f',
            color: 'white'
          }
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </>
  )
}